import cbStyles from '../styles/variables-CB.module.css';
import ckStyles from '../styles/variables-CK.module.css';
import gcsStyles from '../styles/variables-GCS.module.css';
import gcsStylesOrange from '../styles/variables-GCS.orange.module.css';

export const rootStyleVariables = {
  CK: ckStyles.root,
  CB: cbStyles.root,
  GCS: gcsStyles.root,
  GCSOrange: gcsStylesOrange.root,
};
